import { Api } from './Api'

const campaignsPathTo = {
  list: (params) => {
    return Api.request({
      url: '/campaigns.json',
      method: 'get',
      params
    })
  },
  get: (id) => {
    return Api.request({
      url: `/campaigns/${id}.json`,
      method: 'get',
    })
  },
  save: (data) => {
    return Api.request({
      url: '/campaigns.json',
      method: 'post',
      data: { campaign: data }
    })
  },
  update: (id, data) => {
    return Api.request({
      url: `/campaigns/${id}.json`,
      method: 'put',
      data: { campaign: data }
    })
  },
  delete: (id) => {
    return Api.request({
      url: `/campaigns/${id}.json`,
      method: 'delete',
    })
  },
  openEnrollment: (id) => {
    return Api.request({
      url: `/campaigns/${id}/open_enrollment.json`,
      method: 'put',
    })
  },
  activate: (id) => {
    return Api.request({
      url: `/campaigns/${id}/activate.json`,
      method: 'put',
    })
  },
  endCampaign: (id) => {
    return Api.request({
      url: `/campaigns/${id}/end_campaign.json`,
      method: 'put',
    })
  },
  active: () => {
    return Api.request({
      url: '/public/campaigns/active.json',
      method: 'get',
    })
  },
  publicProducts: (slug) => {
    return Api.request({
      url: `/public/campaigns/${slug}/products.json`,
      method: 'get',
    })
  }
}

export default campaignsPathTo
